import { Handshake, UserPlus } from "lucide-react";
import { defineModuleUi } from "@vixio/data";
import { registerAuditLabels, lazyPage } from "@vixio/ui";
import "./api";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const PartnersPage = lazyPage(() => import("./PartnersPage"), "PartnersPage");
const PartnerPage = lazyPage(() => import("./PartnerPage"), "PartnerPage");
const ReferralsPage = lazyPage(() => import("./ReferralsPage"), "ReferralsPage");

registerAuditLabels({
  "partners.partner_created": "Parceiro cadastrado",
  "partners.partner_updated": "Parceiro alterado",
  "partners.term_published": "Termo de parceria publicado",
  "partners.term_accepted": "Termo de parceria aceito",
  "partners.term_ended": "Termo de parceria encerrado",
  "partners.referral_registered": "Indicação registrada",
});

export default defineModuleUi({
  key: "partners",
  title: "Parceiros",
  domain: "relationship",
  icon: Handshake,
  menu: [
    { path: "/relacionamento/parceiros", label: "Parceiros", minRole: "member", icon: Handshake, order: 40, keywords: "sebrae contador advogado termo indicação recíproca comissão" },
    { path: "/relacionamento/indicacoes", label: "Indicações", minRole: "partner", icon: UserPlus, order: 45, keywords: "indicação parceiro origem oportunidade" },
  ],
  routes: [
    { path: "/relacionamento/parceiros", element: <PartnersPage />, minRole: "member" },
    { path: "/relacionamento/parceiros/:id", element: <PartnerPage />, minRole: "member" },
    { path: "/relacionamento/indicacoes", element: <ReferralsPage />, minRole: "partner" },
  ],
});
